export const INITIAL_LOADING_TEXT = 'Loading course data...'
export const UPDATE_LOADING_TEXT = 'Updating class...'
export const DEFAULT_UNIT = 'unit-1'
